import { render } from "./Project_id.vue?vue&type=template&id=851ccc66&scoped=true"
import script from "./Project_id.vue?vue&type=script&lang=js"
export * from "./Project_id.vue?vue&type=script&lang=js"

import "./Project_id.vue?vue&type=style&index=0&id=851ccc66&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851ccc66"]])

export default __exports__